import React, { useState } from 'react';
import styled from 'styled-components';
import Calendar from 'react-calendar';
import { Modal } from 'semantic-ui-react';
import { toastError } from '../../../../utils/toastMessage';

const ChangeComplexStartDateModal = ({ isShow, onClose, changeComplexStartDate }) => {
  const [startComplexDate, setStartComplexDate] = useState(undefined);
  const submitSaveComplex = () => {
    if (!startComplexDate) {
      toastError('Дата старта не выбрана');
      return;
    }
    changeComplexStartDate(startComplexDate);
  };

  if (!isShow) return null;

  return (
    <Modal open={isShow} closeIcon size="tiny" onClose={() => onClose(false)}>
      <WrapBodyModal>
        <SubtitleModal>Начальная дата:</SubtitleModal>
        <Calendar minDate={new Date()} value={startComplexDate} onChange={setStartComplexDate} />
        <CreateComplexButton onClick={submitSaveComplex}>Применить дату старта</CreateComplexButton>
      </WrapBodyModal>
    </Modal>
  );
};

export default ChangeComplexStartDateModal;

const WrapBodyModal = styled.div`
  margin: 7px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const SubtitleModal = styled.div`
  font-size: 20px;
  font-weight: bold;
  margin: 10px 0px;
`;

const CreateComplexButton = styled.button`
  display: block;
  width: 100%;
  height: 40px;
  font-size: 20px;
  margin-top: 20px;
  color: #fff;
  border: none;
  border-radius: 5px;
  background: ${(props) => (props.disabled ? '#999999' : '#157aac')};
  &:hover {
    background: #4f93c3;
    cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  }
`;



// WEBPACK FOOTER //
// ./src/Components/Menus/ControlUsers/ChangeComplexStartDateModal/index.jsx